import React, {useState, useEffect, useRef,forwardRef, useImperativeHandle} from 'react';
import './orders-note.scss';
import Form, {Item, Label} from 'devextreme-react/form';
import orderApi from '../../../api/order';
import notify from 'devextreme/ui/notify';

const Notes = forwardRef((props,ref) => {
    //console.log(props);
    const id = props.id?.toString();
    const notes = props.notes;
    var close = props.close;

    const [internalNoteData,setInterNoteData] = useState();
    const [noteFromBuyerData, setNoteFromBuyerData] = useState();
    const [noteToBuyerData, setNoteToBuyerData] = useState();

    const saveOnClick = (e) =>{
        switch (notes){
            case '1':
                internalNoteOnSubmit(e); break;
            case '2':
                noteFromBuyerOnSubmit(e); break;
            case '3':
                noteToBuyerOnSubmit(e);break;
            default:
                break;
        }
    }

    const internalNoteOnSubmit = async(e) =>{
        //console.log(internalNoteData)
        if(internalNoteData!==null||internalNoteData!== undefined)
        {
            await orderApi.updateManualOrderById(id,{"internalNote":internalNoteData}).then( res =>{
                if(res.status === 200){
                    notify("note added", "success", 500);
                    setInterNoteData('');
                    close(true);
                }
            });
        }
        else close(true);
    }
    const noteFromBuyerOnSubmit = async(e) =>{
        console.log("noteFromBuyerData",noteFromBuyerData)
        if(noteFromBuyerData!==null||noteFromBuyerData!== undefined)
        {
            await orderApi.updateManualOrderById(id,{"noteFromBuyer":noteFromBuyerData}).then( res =>{
                if(res.status === 200){
                    notify("note added", "success", 500);
                    setNoteFromBuyerData('');
                    close(true);
                }
            });
        }
        else close(true);
    }
    const noteToBuyerOnSubmit = async(e) =>{  
        console.log(id,noteToBuyerData); 
        if(noteToBuyerData!==null||noteToBuyerData!== undefined)
        {
            await orderApi.updateManualOrderById(id,{"noteToBuyer":noteToBuyerData}).then( res =>{
                if(res.status === 200){
                    notify("note added", "success", 500);
                    setNoteToBuyerData('');
                    close(true);
                }
            });
        }
        else close(true);
    }
    useImperativeHandle(ref, (e) => ({saveOnClick}));
    switch (notes) {
        case '1':
            return (
                <form onSubmit={internalNoteOnSubmit}>
                    <Form>
                        <Item dataField="internalNote" editorType="dxTextArea" editorOptions={{stylingMode: 'filled',onValueChanged:(value)=>setInterNoteData(value?.value)}}>
                            <Label visible={false}/>
                        </Item>
                    </Form>
                </form>
            );
        case '2':
            return (
                <form>
                    <Form formData={noteFromBuyerData}>
                        <Item dataField="noteFromBuyer" editorType="dxTextArea" editorOptions={{stylingMode: 'filled',onValueChanged:(value)=>setNoteFromBuyerData(value?.value)}}>
                        <Label visible={false}/>
                        </Item>
                    </Form>
                </form>
            );
        case '3':
            return (
                <form>
                    <Form formData={noteToBuyerData}>
                        <Item dataField="noteToBuyer" editorType="dxTextArea" editorOptions={{stylingMode: 'filled',onValueChanged:(value)=>setNoteToBuyerData(value?.value)}}>
                        <Label visible={false}/>
                        </Item>
                    </Form>
                </form>
            );
        default:
            return '404 Page Not Found';
    }

})

export default Notes;